import { Injectable } from '@angular/core';
import { CandidateDetailsReducer } from 'src/app/recruiting/locums-margin-calculator/store/candidate-details/candidate-details.reducer';
import { AdditionalRatesReducer } from '../store/additional-rates/additional-rates.reducer';
import { CandidateSearchReducer } from '../store/candidate-search/candidate-search.reducer';
import { AdditionalRatesEffects } from '../store/effects/additional-rates.effects';
import { CandidateEffects } from '../store/effects/candidate.effects';
import { JobEffects } from '../store/effects/job.effects';
import { LocumsMarginCalculatorEffects } from '../store/effects/locums-margin-calculator.effects';
import { LocumsMarginPipelineRequestEffects } from '../store/effects/locums-margin-pipeline-request.effects';
import { MarginCalculationsEffects } from '../store/effects/margin-calculations.effects';
import { MarginExpensesEffects } from '../store/effects/margin-expenses.effects';
import { JobDetailsReducer } from '../store/job-details/job-details.reducer';
import { LocumsMarginCalculatorReducer } from '../store/locums-margin-calculator.reducer';
import { MarginCalculationsReducer } from '../store/margin-calculations/margin-calculations.reducer';
import { MarginExpensesReducer } from '../store/margin-expenses/margin-expenses.reducer';
import { MarginNotesReducer } from '../store/margin-notes/margin-notes.reducer';
import { MarginSetupReducer } from '../store/margin-setup/margin-setup.reducer';
import { MarginContractReducer } from '../store/margin-contract/margin-contract.reducer';
import { ContractRequestsReducer } from '../store/contract-requests/contract-requests.reducer';
import { MarginRtoDatesReducer } from '../store/margin-rto-dates/margin-rto-dates.reducer';

@Injectable({ providedIn: 'root' })
export class LocumsMarginCalculatorInitializerService {
    constructor(
        protected readonly locumsMarginCalculatorEffects: LocumsMarginCalculatorEffects,
        protected readonly locumsMarginCalculatorReducer: LocumsMarginCalculatorReducer,
        protected readonly locumsMarginPipelineRequestEffects: LocumsMarginPipelineRequestEffects,
        protected readonly jobEffects: JobEffects,
        protected readonly jobDetailsReducer: JobDetailsReducer,
        protected readonly candidateSearchReducer: CandidateSearchReducer,
        protected readonly candidateEffects: CandidateEffects,
        protected readonly marginSetupReducer: MarginSetupReducer,
        protected readonly additionalRatesEffects: AdditionalRatesEffects,
        protected readonly additionalRatesReducer: AdditionalRatesReducer,
        protected readonly marginExpensesEffects: MarginExpensesEffects,
        protected readonly marginExpensesReducer: MarginExpensesReducer,
        protected readonly marginNotesReducer: MarginNotesReducer,
        protected readonly marginCalculationsReducer: MarginCalculationsReducer,
        protected readonly marginCalculationsEffects: MarginCalculationsEffects,
        protected readonly candidateDetailsReducer: CandidateDetailsReducer,
        protected readonly marginContractReducer: MarginContractReducer,
        protected readonly contractRequestsReducer: ContractRequestsReducer,
        protected readonly marginRtoDatesReducer: MarginRtoDatesReducer
    ) {}
}
